import { useQuery } from '@tanstack/react-query';
import React, { useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthProvider';
import useTitle from '../../../hooks/useTitle/useTitle';
import Loading from '../../../Shared/Loading/Loading';
import Orders from '../Orders/Orders';

const MyOrders = () => {
    const { user } = useContext(AuthContext);
    useTitle('MyOrders-Dasboard');

    const { data: bookings = [], isLoading, refetch } = useQuery({
        queryKey: ['bookings', user?.email],
        queryFn: async () => {
            const res = await fetch(`https://bike-resell-shop-server.vercel.app/bookings?email=${user?.email}`, {
                headers: {
                    authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            });
            const data = await res.json();
            return data;
        }
    })

    if (isLoading) {
        return <Loading></Loading>
    }

    return (
        <div className='mt-5'>
            <h1 className='text-3xl font-bold text-center underline'>Total Orders: {bookings.length}</h1>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 p-5'>
                {
                    bookings.map(booked => <Orders
                        key={booked._id}
                        booked={booked}
                        refetch={refetch}
                    ></Orders>)
                }
            </div>
        </div>
    );
};

export default MyOrders;